class ProgressBar {
  constructor(freeShippingAmount, cartTotal) {
    this.freeShippingAmount = freeShippingAmount;
    this.cartTotal = cartTotal;
    this.init();
  }
  init() {
    this.element = document.getElementById("progress-bar");
    this.elementInner = this.element.querySelector(".progress-bar-inner");
    this.updateProgressbar(this.freeShippingAmount, this.cartTotal);
  }

  updateProgressbar(freeShippingAmount, cartTotal) {
    let percent = Math.round((cartTotal / freeShippingAmount) * 100);
    if (percent > 100) {
      percent = 100;
    }
    this.elementInner.style.width = `${percent}%`;
  }
}
